import { render, staticRenderFns } from "./UpcomingAnniversaries.vue?vue&type=template&id=f2d5571c&"
import script from "./UpcomingAnniversaries.vue?vue&type=script&lang=js&"
export * from "./UpcomingAnniversaries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports